import React, {useEffect, useState} from "react";
import styles from "../../styles/create_styles.module.scss";
import {ReactComponent as Arrow} from "../../assets/icons/arrow-left.svg";

import Select from "react-select";

import {useParams} from "react-router-dom";
import {useMutation, useQuery} from "react-query";
import {getTeam, storeTeam,} from "../../services/services";
import {toast} from "react-toastify";
import {Form, Formik} from "formik";
import {BarLoader} from "react-spinners";
import Button from "../../components/Button/Button";
import {ReactComponent as Upload} from "../../assets/icons/upload.svg";
import {IGetTeam, IPostTeam} from "../../ts/interfaces/Team/interface";
import {queryClient} from "../../services/queryClient";


const CreateTeam: React.FC = () => {
    const queryParams = useParams();

    document.title = 'Admin - ' + (queryParams?.id ? 'Editar' : 'Cadastrar') + ' time';

    const [logo, setLogo] = useState<string | null>(null);

    const stylesSelect = {
        control: (styles: any) => ({
            ...styles,
            width: "100%",
            height: "37px",
        }),
        indicatorsContainer: (styles: any) => ({
            ...styles,
            height: "37px",
        }),
        valueContainer: (styles: any) => ({
            ...styles,
            height: "37px",
            display: "flex",
            alignItems: "center",
            padding: "0px 8px",
            "overflow-y": "auto"
        }),
        dropdownIndicator: (styles: any) => ({
            ...styles,
            padding: "4px",
        }),
        clearIndicator: (styles: any) => ({
            ...styles,
            padding: "4px",
        }),
    };

    const {data, isLoading} = useQuery<{
        data: IGetTeam;
        status: number
    }>(
        ["team", queryParams?.id],
        () => getTeam(parseInt(queryParams?.id ?? "0")),
        {

            staleTime: Infinity,
            enabled: !!queryParams?.id,
        }
    );

    if (!isLoading && queryParams?.id && data?.status !== 200) {
        window.location.href = '/team';
    }

    const [params, setParams] = useState<IPostTeam>({
        id: null,
        name: "",
        abbreviation: "",
        logo: null,
        country: null,
        league: null,
    });

    useEffect(() => {
        if (data && data.data) {
            setParams({
                ...params,
                id: data.data.id,
                name: data.data.name,
                abbreviation: data.data.abbreviation,
                logo: data.data.logo,
                country: data.data.country,
                league: data.data.league
            });
        }
    }, [data]);

    useEffect(() => {
        queryClient.invalidateQueries(["team", queryParams?.id])
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
        setParams({...params, [e.target.name]: e.target.value});
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            setParams((prevParams) => ({
                ...prevParams,
                [e.target.name]: file,
            }));
            setLogo(file.name)
        }
    };

    const onSubmit = () => {
        if (!params.name || params.name.trim() === "") {
            toast.error("Preencha o nome.");
            return;
        }

        const formData = new FormData();

        formData.append("id", params.id ? params.id.toString() : "");
        formData.append("name", params.name ?? "");
        formData.append("abbreviation", params.abbreviation ?? "");
        formData.append("country", params.country ?? "");
        formData.append("league", params.league ?? "");

        if (params.logo instanceof File) {
            formData.append("logo", params.logo);
        }

        mutate.mutate(formData);
    };

    const mutate = useMutation(
        (data: FormData) => {
            return storeTeam(data);
        },
        {
            onSettled: (response) => {
                if (response?.data?.success) {
                    toast.success("Salvo com sucesso!");
                    queryClient.invalidateQueries(['filter-teams'])

                    setTimeout(() => {
                        window.location.href = "/teams";
                    }, 800);
                } else {
                    toast.error("Erro ao salvar o time. " + (response?.data?.msg ?? ''));
                }
            },
            onError: (error) => {
                toast.error("Erro ao salvar o time");
            },
        }
    );

    return (
        <>
            <Formik
                initialValues={{
                    name: "",
                    sku: "",
                    url: "",
                }}
                onSubmit={() => onSubmit()}
            >
                <Form className={styles.container}>
                    <div className={styles.content}>
                        <div className={styles.title}>
                            <a
                                href="/teams"
                                className={styles.btnReturn}
                            >
                                <Arrow/> Voltar
                            </a>
                            <h1>
                                {params.id ? "Editar" : "Cadastrar"} Time
                            </h1>
                        </div>
                        {isLoading ? (
                            <div className={styles.alignCenter}>
                                <span>Carregando</span>
                                <BarLoader
                                    color={"#ff7526"}
                                    loading={isLoading}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                />
                            </div>
                        ) : (
                            <>
                                <div className={styles.box}>
                                    <p className={styles.boxTitle}>
                                        Informe os dados do time {queryParams?.id}
                                    </p>
                                    <div className={styles.groupData}>
                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="name">
                                                    Nome
                                                </label>
                                                <input
                                                    disabled={mutate.isLoading}
                                                    value={params.name}
                                                    onChange={(e) =>
                                                        handleChange(e)
                                                    }
                                                    className={styles.input}
                                                    type="text"
                                                    name="name"
                                                    id="name"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="abbreviation">
                                                    Abreviação
                                                </label>
                                                <input
                                                    disabled={mutate.isLoading}
                                                    value={params.abbreviation ?? ""}
                                                    onChange={(e) =>
                                                        handleChange(e)
                                                    }
                                                    className={styles.input}
                                                    type="text"
                                                    name="abbreviation"
                                                    id="abbreviation"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="country">
                                                    País
                                                </label>
                                                <Select
                                                    defaultValue={{
                                                        value: data?.data.country,
                                                        label: data?.data.country_name ?? "",
                                                    }}
                                                    name="country"
                                                    styles={stylesSelect}
                                                    options={[
                                                        {value: "BR", label: "Brasil"},
                                                        {value: "AR", label: "Argentina"},
                                                        {value: "FR", label: "França"},
                                                        {value: "IT", label: "Itália"},
                                                        {value: "DE", label: "Alemanha"},
                                                        {value: "ES", label: "Espanha"},
                                                        {value: "PT", label: "Portugal"},
                                                        {value: "GB", label: "Inglaterra"},
                                                        {value: "US", label: "Estados Unidos"},
                                                        {value: "MX", label: "México"},
                                                        {value: "JP", label: "Japão"},
                                                        {value: "NL", label: "Holanda"},
                                                        {value: "BE", label: "Bélgica"},
                                                        {value: "CH", label: "Suíça"},
                                                        {value: "UR", label: "Uruguai"},
                                                        {value: "SA", label: "Arábia Saudita"},
                                                    ]}
                                                    onChange={(
                                                        selectedOption
                                                    ) => {
                                                        setParams({
                                                            ...params,
                                                            country:
                                                                selectedOption?.value ??
                                                                null,
                                                        });
                                                    }}
                                                    placeholder="Selecione o país..."
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="league">
                                                    Liga
                                                </label>
                                                <Select
                                                    defaultValue={{
                                                        value: data?.data.league,
                                                        label: data?.data.league,
                                                    }}
                                                    name="league"
                                                    styles={stylesSelect}
                                                    options={[
                                                        {value: "Campeonato Brasileiro", label: "Campeonato Brasileiro"},
                                                        {value: "La Liga", label: "La Liga"},
                                                        {value: "Serie A", label: "Serie A"},
                                                        {value: "Bundesliga", label: "Bundesliga"},
                                                        {value: "Ligue 1", label: "Ligue 1"},
                                                        {value: "Premier League", label: "Premier League"},
                                                        {value: "Primeira Liga", label: "Primeira Liga"},
                                                        {value: "Eredivisie", label: "Eredivisie"},
                                                        {value: "Primera División", label: "Primera División"},
                                                        {value: "Liga MX", label: "Liga MX"},
                                                        {value: "Major League Soccer", label: "Major League Soccer"},
                                                        {value: "J-League", label: "J-League"},
                                                        {value: "Seleção", label: "Seleção"},
                                                    ]}
                                                    onChange={(
                                                        selectedOption
                                                    ) => {
                                                        setParams({
                                                            ...params,
                                                            league:
                                                                selectedOption?.value ??
                                                                "",
                                                        });
                                                    }}
                                                    placeholder="Selecione a liga..."
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="logo">
                                                    Escudo
                                                </label>
                                                <div
                                                    className={styles.fileInput}
                                                >
                                                    <input
                                                        disabled={
                                                            mutate.isLoading
                                                        }
                                                        onChange={(e) => {
                                                            handleFileChange(e);
                                                        }}
                                                        className={styles.input}
                                                        type="file"
                                                        name="logo"
                                                        id="logo"
                                                    />
                                                    {logo ? (
                                                        <span>
                                                            {" "}
                                                            <Upload/>{" "}
                                                            <p>{logo}</p>
                                                        </span>
                                                    ) : (
                                                        <span>
                                                            <Upload/> <p>Faça o
                                                            upload do escudo</p>
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            {typeof params.logo ===
                                                "string" && (
                                                    <div
                                                        className={
                                                            styles.urlNoticeContainer
                                                        }
                                                    >
                                                        Arquivo:{" "}
                                                        <a
                                                            href={params.logo}
                                                            className={
                                                                styles.urlNotice
                                                            }
                                                            target="_blank"
                                                        >
                                                            {params.logo}
                                                        </a>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.box}>
                                    <div className={styles.alignButtons}>
                                        <Button
                                            disabled={mutate.isLoading}
                                            width="175px"
                                            height="50px"
                                            type="submit"
                                        >
                                            Salvar
                                        </Button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </Form>
            </Formik>
        </>
    );
};

export default CreateTeam;
